import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function EmptyState({
  icon: Icon,
  title,
  body,
  action,
  info,
}: {
  icon: LucideIcon;
  title: string;
  body: string;
  action?: ReactNode;
  /** Optional quiet ⓘ beside the title (an InfoTip). */
  info?: ReactNode;
}) {
  return (
    <div className="surface-card-tight p-10 flex flex-col items-center text-center gap-4">
      <span
        className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-accent-muted text-accent"
        aria-hidden
      >
        <Icon size={24} strokeWidth={1.75} />
      </span>
      <div className="space-y-1.5">
        <p className="inline-flex items-center gap-1.5 text-sm font-semibold text-text-primary tracking-tight">
          {title}
          {info}
        </p>
        <p className="text-xs leading-relaxed text-text-muted max-w-sm">{body}</p>
      </div>
      {action}
    </div>
  );
}
